import Navbar from "./components/NavBar";
import Main from "./components/Main";

function App() {
  return (
    <div>
      <Navbar />
      <Main />
    </div>
  );
}

export default App;
